module.exports = __webpack_public_path__ + "img/icon_user_qianbao.123f520b.png";